export default __webpack_public_path__ + "static/media/cards_flips_7.0c6dfed3.mp3";